module.exports = __webpack_public_path__ + "static/media/camera-on.a971b711.png";